import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "@/constants/routes";
import { alertsRepo } from "@/lib/repositories";

export function useFetchAlert(id: string | undefined) {
  const navigate = useNavigate();
  const query = useQuery({
    queryKey: ["alert", id],
    queryFn: () => alertsRepo.fetchOne(id!),
    enabled: !!id,
    gcTime: 0,
  });

  useEffect(() => {
    if (query.error) {
      navigate(ROUTES.WARNINGS);
    }
  }, [query.error, navigate]);

  return {
    alert: query.data,
    isLoading: query.isLoading,
  };
}
